import { render, staticRenderFns } from "./ScrollToOffsetXIcon.vue?vue&type=template&id=15c94675&"
import script from "./ScrollToOffsetXIcon.vue?vue&type=script&lang=js&"
export * from "./ScrollToOffsetXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports